import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import {
  ContactWithGeneralEmail,
  SeverityLevelContact,
} from '../../data/severity-level-contacts';

type SeverityContact = SeverityLevelContact['contacts'][number];

@Component({
  selector: 'app-severity-level-contacts-grid',
  templateUrl: './severity-level-contacts-grid.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule, RouterModule],
})
export class SeverityLevelContactsGridComponent {
  @Input() caption = 'Severity level contacts and escalation procedures';

  @Input() severityLevelContacts: SeverityLevelContact[] = [];

  public severityLevelContactRowSpan(
    severityLevelContact: SeverityLevelContact,
  ): number {
    return Math.max(severityLevelContact.contacts.length, 1);
  }

  public hasGeneralEmail(
    severityLevelContact: SeverityLevelContact,
  ): severityLevelContact is ContactWithGeneralEmail {
    return (
      'generalEmail' in severityLevelContact &&
      severityLevelContact.generalEmail !== undefined
    );
  }

  public contactEmail(contact: SeverityContact): string | undefined {
    return 'email' in contact ? contact.email : undefined;
  }

  public phoneHref(phoneNumber: string): string {
    return `tel:${phoneNumber.replace(/[^\d+]/g, '')}`;
  }

  public phoneTypeLabel(phoneType: 'CEL' | 'OFF'): string {
    return phoneType === 'CEL' ? 'Cell phone' : 'Office phone';
  }

  public phoneTypeIcon(phoneType: 'CEL' | 'OFF'): string {
    return phoneType === 'CEL' ? 'smartphone' : 'phonelink';
  }
}
